import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {
  data: [],
  setAsidesLoading: false,
  setAsidesLoaded: false,
};

const setAsidesSlice = createSlice({
  name: "setAsides",
  initialState: INITIAL_STATE,
  reducers: {
    reset() {
      return INITIAL_STATE;
    },
    setSetAsides(state, { payload }) {
      state.data = payload || [];
    },
    setSetAsidesLoading(state, { payload }) {
      state.setAsidesLoading = payload;
    },
    setSetAsidesLoaded(state, { payload }) {
      state.setAsidesLoaded = payload;
    },
  },
});

export const {
  reset,
  setSetAsides,
  setSetAsidesLoading,
  setSetAsidesLoaded,
} = setAsidesSlice.actions;

export default setAsidesSlice;
